import type { UseQueryResult } from '@tanstack/react-query';
import { useLegacySignupParams } from './useLegacySignupParams';
import { useSignupSponsor } from './useSignupSponsor';
import type { SignupSponsor } from '../services/signup-api/signup-api';
import { signupPathFor } from '../steps';
import { useSignupFlowStore } from '../stores/signup-flow-store';

/**
 * The sponsor reference later steps resolve: the link's, or the one picked in
 * search. Only a link without an employer searches; an employer link and an
 * employer SSO arrival both carry theirs on the URL.
 */
export function useActiveSponsorQuery(): { clientId?: string; subClientId?: string } {
  const params = useLegacySignupParams();
  const sponsorRef = useSignupFlowStore((state) => state.sponsorRef);
  if (signupPathFor(params) !== 'no-employer') {
    return { clientId: params.clientId, subClientId: params.subClientId };
  }
  return sponsorRef === null ? {} : { clientId: sponsorRef };
}

/**
 * The sponsor for the steps after the link's own: on an employer link, the one
 * it names; on a link without one, the employer the member picked in search,
 * sent back as the directory gave it. With no pick yet it resolves nothing,
 * exactly as a link without an employer always has.
 */
export function useActiveSignupSponsor(): UseQueryResult<SignupSponsor> {
  const { clientId, subClientId } = useActiveSponsorQuery();
  return useSignupSponsor(clientId, subClientId);
}
